<template>
  <header class="shadow-sm">
    <b-container>
      <b-row>
        <b-col md="9" cols="6">
          <div class="logo">
            <router-link to="/uebersicht">
              <img src="~@/assets/img/energieagentur.svg" alt="Energie-Agentur" />
            </router-link>
          </div>
        </b-col>
        <b-col md="3" cols="6" align-self="center">
          <avatar-dropdown/>
          <b-navbar toggleable="lg" class="nav-burger">
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
          </b-navbar>
        </b-col>
      </b-row>
    </b-container>
  </header>
</template>

<script>
  import AvatarDropdown from '@/components/layout/AvatarDropdown.vue'

  export default {
    components: {
      AvatarDropdown
    }
  }
</script>

<style lang="scss" scoped>
  header{
    padding: 1rem 0;
    background: $white;

    .logo{
      width: 170px;

       @include media-breakpoint-down(xs) {
          max-width: 150px;
       }
    }
    .nav-burger{
      float: right;
      padding-right: 0;
    }

    .navbar{
      .navbar-toggler{
        border: none;
        padding: 0.25rem 0.45rem 0 0.75rem;
      }
    }
  }

</style>
